<template>
  <div class="app">
    <router-view />
  </div>
</template>

<style>
@import "../public/css/style.css";
</style>
